import React from 'react';
import styled from 'styled-components';
import data from './data';
import Organizations from './organizations';
import { ContentWrap, Wrapper } from '../common';
import { breakpointsMinWidth } from '../../../../../common/styling';

const HeadingText = styled.div`
  color: rgb(111, 115, 129);
  font-size: 14px;
  font-weight: 500;
  line-height: 2;
  text-align: center;

  @media ${breakpointsMinWidth.tabletSm} {
    font-size: 16px;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    font-size: 18px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 20px;
  }
`;

const Affiliations = () => {
  return (
    <Wrapper>
      <ContentWrap>
        <HeadingText>ORGANIZATIONS THAT TRUST WISEDOC</HeadingText>
        <Organizations data={data.UnivLogos} />
      </ContentWrap>
    </Wrapper>
  );
};

export default Affiliations;
